<template>
  <div class="cloud-links">
    <template v-if="blnCloudLinks">
      <span class="people-search">大家都在搜索：</span>
      <a v-for="(arrLinkInfo,index) in arrLinks" v-bind:key="index" v-bind:href="arrLinkInfo.url" target="_blank" v-text="arrLinkInfo.name" @click="reportClick(arrLinkInfo, index)"></a>
    </template>
  </div>
</template>
<script>
import stats from '../api/statistics'
import wl from '../api/wordslinks';
var blnDebug = true;
export default {
  name: 'HotWords',
  data () {
    return {
      blnCloudLinks: false,
      arrLinks: [],
      startTime: (new Date() - 0)
    }
  },
  created () {
    // this.debugLog('文字链展示上报:Error_hotlink_show')
    stats.ajax99('Error_hotlink_show');
    this.getWordsLinks()
  },
  methods: {
    reportClick (linkInfo, index) {
      // this.debugLog('文字链点击上报:Error_hotlink_push')
      stats.ajax99('Error_hotlink_push');
      wl.ajax131(linkInfo.md5, linkInfo.ggid, index, 'cu1000181', this.startTime)
    },
    getWordsLinks () {
      var self = this
      wl.getWordLinksList({
        count: 6
      }, (err, list) => {
        if (err || list.length <= 0) {
          self.blnCloudLinks = false
        } else {
          self.blnCloudLinks = true
          var arrMd5s = [], arrGgIds = []
          list.forEach(function (adInfo) {
            arrGgIds.push(adInfo.ggid)
            arrMd5s.push(adInfo.md5)
          })
          wl.ajax132(arrMd5s.join('|'), arrGgIds.join('|'))
          self.arrLinks = list
        }
      })
    },
    debugLog () {
      if (blnDebug) {
        for (var idx in arguments) {
          console.log(arguments[idx])
        }
      }
    }
  }
}
</script>
